import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // Define routes where scroll to top should NOT happen
  const preserveScrollRoutes = [
    '/products', '/unit', '/pincode', '/delivery',
    '/features', '/category', '/coupon', '/orders',
    '/customer', '/invoice', '/leads', '/expense'
  ];

  useEffect(() => {
    const shouldPreserve = preserveScrollRoutes.includes(pathname);
    if (!shouldPreserve) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
